import { ITjipBusyPromise, tjipBusyService } from '@/services/tjipBusyService';
import { BOverlay } from 'bootstrap-vue';
import Vue from 'vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';

@Component
export default class AppBusyOverlayComponent extends Vue {
  @Prop()
  public name?: string;
  @Prop()
  public fullScreen?: boolean;
  @Ref('trap')
  private focusTrap!: HTMLElement;
  @Ref('start')
  private focusStart!: HTMLElement;
  @Ref('end')
  private focusEnd!: Element;
  @Ref('bOverlay')
  private bOverlay!: BOverlay;

  private focusListener!: () => void;

  mounted(): void {
    this.bOverlay.$on('shown', () => {
      this.bOverlay.$el.classList.add('loaded');
    });
    // this.bOverlay.$on('hidden', () => {
    //   this.$log.debug(this.bOverlay.$el);
    //   this.bOverlay.$el.classList.remove('loaded');
    // });
    this.focusListener = this.onFocus.bind(this);
    this.focusStart.addEventListener('focus', this.focusListener);
    this.focusEnd.addEventListener('focus', this.focusListener);
  }

  beforeDestroy() {
    this.focusStart.addEventListener('focus', this.focusListener);
    this.focusEnd.addEventListener('focus', this.focusListener);
  }

  private focus() {
    const x = window.scrollX,
      y = window.scrollY;
    this.focusTrap.focus();
    window.scrollTo(x, y);
  }

  private onFocus() {
    this.focus();
  }

  @Watch('show')
  private watchShow(val: boolean) {
    if (val) {
      this.focus();
    }
  }

  private get busyPromise(): ITjipBusyPromise {
    const k = this.name || 'busy';
    return tjipBusyService.promise(k);
  }

  public get show(): boolean {
    return !!this.busyPromise.value;
  }
}
